export const ALLOWED_FILE_TYPES = ["image/png", "image/jpeg"];
// OpenAI's image processing doesn't seem to care about the orientation of the
// image, just the dimensions.
export const OPENAI_MAX_SHORT_DIMENSION = 768;
export const OPENAI_MAX_LONG_DIMENSION = 2000;
